<template>
    <div v-if="isTextToImage" class="image-effects-test-prompt">
        <div
            class="form-group mb-0 d-flex align-items-end prompt-row mb-4"
            :class="{ 'prompt-row--stacked': alwaysStacked }"
        >
            <c-input
                v-model="prompt"
                type="text"
                class="flex-grow-1"
                placeholder="Type a prompt to generate a test image"
                label="Type a prompt to generate a test image"
            />
            <c-button size="md" text="Generate" variant="light" :disabled="!prompt.trim()" @click="handleGenerate" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import CButton from '@/components/shared/CButton';
import CInput from '@/components/shared/CInput';
import type { ImagePlaceholderElement } from '@/typings/customilyElements/canvasElements';
import { isTextToImageEffect } from '@/typings/customilyElements/imageEffectType';

interface Props {
    imageElement: ImagePlaceholderElement;
    alwaysStacked?: boolean;
}

const props = defineProps<Props>();

const emit = defineEmits<{
    (event: 'is-text-to-image-effect', value: boolean): void;
    (event: 'generate-prompt', prompt: string): void;
}>();

const prompt = ref('');

const isTextToImage = computed(() => {
    const type = props.imageElement?.imageEffects?.[0]?.type;
    if (!type) return false;
    return isTextToImageEffect(type);
});

watch(isTextToImage, (value) => emit('is-text-to-image-effect', value), { immediate: true });

const handleGenerate = () => {
    const trimmedPrompt = prompt.value.trim();
    if (!trimmedPrompt) return;

    emit('generate-prompt', trimmedPrompt);
};
</script>

<style scoped lang="scss">
.image-effects-test-prompt {
    width: 100%;
}

.prompt-row {
    gap: 0.5rem;

    @media (max-width: 992px) {
        flex-direction: column;
        align-items: stretch;

        :deep(.c-button-wrapper) {
            width: 100%;
        }
    }

    &--stacked {
        flex-direction: column;
        align-items: stretch;

        :deep(.c-button-wrapper) {
            width: 100%;
        }
    }
}

.w-full {
    width: 100%;
}
</style>
